import { type WalletBalancesQueryProps, useWalletBalancesQuery } from '@/queries/walletBalances.query'
import { captureException } from '@sentry/react-router'
import { useMemo } from 'react'
import { groupBalances } from './groupBalances'

export const useGroupedBalances = ({ address }: WalletBalancesQueryProps) => {
  const { data } = useWalletBalancesQuery({ address })

  return useMemo(() => {
    if (data === undefined || data === null) {
      return null
    }
    if (!Array.isArray(data)) {
      captureException(new Error('Invalid data for useGroupedBalances'), {
        extra: { data },
      })
      return null
    }

    return groupBalances(data, ({ symbol }) => symbol)
  }, [address, data])
}

export type AssetsBalanceGroup = NonNullable<ReturnType<typeof useGroupedBalances>>
